import {Injectable} from '@angular/core';
import {ActivatedRoute, ActivatedRouteSnapshot, Router, RouteReuseStrategy, RunGuardsAndResolvers} from '@angular/router';

@Injectable()
export class RouterActionsService {
    public constructor(
        protected readonly router: Router,
        protected readonly routeReuseStrategy: RouteReuseStrategy,
    ) {
    }

    public reload($forceGuardsAndResolvers: boolean = true): Promise<boolean> {

        const undoChangeReuseStrategy = this.changeReuseStrategy(() => false);
        const undoChangeRunGuardsAndResolvers = $forceGuardsAndResolvers
            ? this.changeRunGuardsAndResolvers(this.router.routerState.root, 'always')
            : () => {};

        return this.router
            .navigateByUrl(this.router.url, {
                onSameUrlNavigation: 'reload'
            })
            .then($ => {
                return $;
            })
            .finally(() => {
                // Restore previous values.
                undoChangeReuseStrategy();
                undoChangeRunGuardsAndResolvers();
            });
    }

    protected changeReuseStrategy($newValue: (future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot) => boolean): () => void {
        const previousValue = this.routeReuseStrategy.shouldReuseRoute;
        this.routeReuseStrategy.shouldReuseRoute = $newValue;

        return () => {
            this.routeReuseStrategy.shouldReuseRoute = previousValue;
        };
    }

    protected changeRunGuardsAndResolvers($route: ActivatedRoute, $newValue: RunGuardsAndResolvers, $forOutlet?: string): () => void {
        const hasRouteConfig = !!$route.routeConfig;
        let undoHasRouteConfig: () => void;
        if (hasRouteConfig) {
            const oldValue = $route.routeConfig.runGuardsAndResolvers;
            $route.routeConfig.runGuardsAndResolvers = $newValue;

            undoHasRouteConfig = () => {
                $route.routeConfig.runGuardsAndResolvers = oldValue;
            };
        }

        const hasChildren = Array.isArray($route.children) && $route.children.length;
        if (hasChildren) {
            const restoreChangeRunGuardStrategy = $route.children
                .filter($ => !$forOutlet || $.outlet === $forOutlet)
                .map($ => this.changeRunGuardsAndResolvers($, $newValue));

            return () => {
                if (undoHasRouteConfig) {
                    undoHasRouteConfig();
                }
                restoreChangeRunGuardStrategy.every($ => $());
            };
        }

        return undoHasRouteConfig || (() => {});
    }
}
